var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _path10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 137,
    viewBox: "0 0 119 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.685 0.800378C26.2025 1.04463 25.7547 1.34619 25.3573 1.7L8.83941 16.4047C8.33009 16.8582 7.91718 17.3821 7.61258 17.9513H26.0138C26.3844 17.9513 26.685 17.6477 26.685 17.2838V0.800378ZM7 21.9513V125.446C7 128.541 9.83268 131.062 13.3092 131.062H104.691C108.167 131.062 111 128.541 111 125.446V5.67912C111 2.58425 108.167 0.0625 104.691 0.0625H30.685V17.2838C30.685 19.8797 28.5705 21.9513 26.0138 21.9513H7Z",
    fill: "#E4EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8281 61.2344V56.0391L31.5469 37.7188H39.9453V56H43.3828V61.2344H39.9453V66H33.5781V61.2344H19.8281ZM26.4688 56H33.6953V44.7891H33.4609L26.4688 55.7656V56ZM58.5 66.3906C51.1562 66.3906 46.6641 61.1367 46.6641 51.8594C46.6641 42.582 51.1562 37.3281 58.5 37.3281C65.8438 37.3281 70.3555 42.6211 70.3359 51.8594C70.3555 61.1562 65.8438 66.3906 58.5 66.3906ZM53.5 51.8594C53.4805 58.1289 55.4922 60.9609 58.5 60.9609C61.5078 60.9609 63.5195 58.1289 63.5 51.8594C63.5 45.6875 61.5078 42.7383 58.5 42.7188C55.5117 42.7383 53.5195 45.6875 53.5 51.8594ZM73.8125 61.2344V56.0391L85.5312 37.7188H93.9297V56H97.3672V61.2344H93.9297V66H87.5625V61.2344H73.8125ZM80.4531 56H87.6797V44.7891H87.4453L80.4531 55.7656V56Z",
    fill: "#C6DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79H86",
    stroke: "#C6DAFF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 90H41",
    stroke: "#C6DAFF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 90H86",
    stroke: "#C6DAFF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4465 110.579C44.5505 110.579 30 96.0992 30 78.2896C30 60.4801 44.5505 46 62.4465 46C80.3426 46 94.8931 60.4801 94.8931 78.2896C94.8931 96.0992 80.3426 110.579 62.4465 110.579ZM62.4465 50.3053C46.9443 50.3053 34.3262 62.8624 34.3262 78.2896C34.3262 93.7169 46.9443 106.274 62.4465 106.274C77.9488 106.274 90.5669 93.7169 90.5669 78.2896C90.5669 62.8624 77.9488 50.3053 62.4465 50.3053Z",
    fill: "#C6DAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.985 105.972L87.9762 107.971C86.2626 109.676 86.2626 112.441 87.9762 114.146L107.758 133.833C109.472 135.538 112.25 135.538 113.964 133.833L115.972 131.834C117.686 130.128 117.686 127.364 115.972 125.658L96.1902 105.972C94.4767 104.267 91.6985 104.267 89.985 105.972Z",
    fill: "#C6DAFF",
    stroke: "#C6DAFF",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.5,
    cy: 78,
    rx: 28.5,
    ry: 28,
    fill: "#F0F8FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5606 73.5548C42.3876 73.5548 42.2001 73.5261 42.0271 73.4544C41.2916 73.153 40.9311 72.3206 41.2195 71.5887C44.1181 64.3702 50.045 58.8738 57.486 56.5346C58.2503 56.2906 59.0579 56.7068 59.2886 57.4674C59.5338 58.228 59.1156 59.0317 58.3513 59.2613C51.7322 61.3422 46.4686 66.2215 43.8873 72.6507C43.6566 73.2104 43.123 73.5548 42.5462 73.5548H42.5606Z",
    fill: "#C6DAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8151 82.5954C40.022 82.5954 39.373 81.9496 39.373 81.1603C39.373 79.8113 39.474 78.448 39.6903 77.1133C39.8201 76.324 40.5555 75.8074 41.3343 75.9222C42.1274 76.0513 42.661 76.7832 42.5312 77.5582C42.3437 78.735 42.2572 79.9548 42.2572 81.1603C42.2572 81.9496 41.6083 82.5954 40.8151 82.5954Z",
    fill: "#C6DAFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9744 18H7L27 0V0.514286V16.9714C27 17.7943 26.3162 18 25.9744 18Z",
    fill: "#C6DAFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error_404.87215b810a793fae8859f38fa87a1875.svg";
export { ForwardRef as ReactComponent };